import React, { useState, useEffect } from "react";
import "./CallForPapersSidebar.css";
import { Link, useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../Admin/API/ApiUrl";
import { useQuery } from "@tanstack/react-query";

export default function CallForPapersSidebar() {
  const navigate = useNavigate();

  const fetchCfp = async () => {
    const response = await fetch(`${ApiUrl}/call-for-papers`);
    const data = await response.json();

    if (!response.ok) {
      throw new Error("Failed to fetch CFP data");
    }

    // normalize response
    if (Array.isArray(data) && data.length > 0) {
      return data[0];
    }

    return data || null;
  };

  const { data: cfpData = null, isLoading, isError } = useQuery({
    queryKey: ["callForPapers"],
    queryFn: fetchCfp,
    staleTime: 10 * 60 * 1000, // 10 mins cache
  });

  if (isLoading) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <aside className="cfp-sidebar">
      {cfpData && (
        <>
          <div className="cfp-box cfp-call">
            <p className="cfp-call-header">
              {cfpData?.call_title} - {formatDate(cfpData?.start_date)}
            </p>

            <p className="cfp-issue">
              Vol {cfpData?.volume} Issue {cfpData?.issue}
            </p>
          </div>

          <div className="cfp-deadline-box">
            <h4 className="cfp-deadline-title">Submission Deadline</h4>

            <p className="cfp-deadline-date">
              {formatDate(cfpData?.submission_deadline)}
            </p>

            <p className="cfp-status">
              Status Notification - {formatDate(cfpData?.review_date)}
            </p>

            <p className="cfp-publication">
              Final Publication - {formatDate(cfpData?.publication_date)}
            </p>
            <Link to={"/OnlineSubmission"}>
              <button
                className="cfp-submit-btn"
              // onClick={() => navigate("/OnlineSubmission")}
              >
                <span className="cfp-submit-btn-text">
                  Submit Paper Here
                </span>
              </button>
            </Link>
          </div>
        </>
      )}
    </aside>
  );
}
